import React, { Component } from 'react';
import { Form } from 'antd'

import InputCustom from '../../components/default/InputCustom'
import SelectCustom from '../../components/default/SelectCustom'
import ButtonCustom from '../../components/default/ButtonCustom'
import TextEditorCustom from '../../components/TextEditorCustom'

import { connect } from 'react-redux'
import { fetchCategoriesBoard } from '../../actions/categoryBoard'
import { fetchBoard, updateBoard } from '../../actions/board'

class EditTopic extends Component {
    state = {
        board: {
            id: 0,
            detail: 'เนื้อหาจำลองแบบเรียบๆ ที่ใช้กันในธุรกิจงานพิมพ์หรืองานเรียงพิมพ์ มันได้กลายมาเป็นเนื้อหาจำลองมาตรฐานของธุรกิจดังกล่าวมาตั้งแต่ศตวรรษที่ 16 เมื่อเครื่องพิมพ์โนเนมเครื่องหนึ่งนำรางตัวพิมพ์มาสลับสับตำแหน่งตัวอักษร เพื่อทำหนังสือตัวอย่าง Lorem Ipsum อยู่ยงคงกระพันมาไม่ใช่แค่เพียงห้าศตวรรษ'
        }
    }

    componentDidMount = () => {
        const id = this.props.match.params.id
        this.props.fetchBoard(id)
        this.props.fetchCategoriesBoard()
    }

    static getDerivedStateFromProps(nextProps, prevState){
        if(Object.keys(nextProps.board).length > 0 && prevState.board.id === 0){
            const board = { ...nextProps.board }
            return { board }
        }
        else return null;
	}

    onSubmit = (e) => {
        e.preventDefault()
		let board = { ...this.state.board }
        this.props.updateBoard(board)
    }
    
    onCategoryChange = (id) => {
        let board = { ...this.state.board }
        board.category_id = id
        this.setState({ board })
    }

    onInputChange = (event) => {
        const name = event.target.name
        let board = { ...this.state.board }
        board[name] = event.target.value
        this.setState({ board })
    }
    
    render() {
        if(Object.keys(this.props.board).length > 0){
            const {id, title, category_id, detail} = this.state.board
            return (
                <div className="new-topic-page-wrap">
                    <div className="new-topic-page-title gapb-32">ตั้งกระทู้ใหม่</div>
                    <div className="new-topic-page">
                        <div className="new-topic-title gapb-24">ข้อมูลกระทู้</div>
                        <Form onSubmit={this.onSubmit}>
                            <InputCustom
                                label="หัวข้อ"
                                labelColor="65"
                                size="large"
                                type="text"
                                required
                                placeholder="หัวข้อ"
                                marginBottom="16"
                                name="title"
                                value={title}
                                onChange={this.onInputChange}
                            />
                            <SelectCustom
                                label="หมวดหมู่"
                                placeholder="หมวดหมู่"
                                size="large"
                                labelColor="65"
                                marginBottom="16"
                                showSearch
                                defaultValue={category_id}
                                onChange={this.onCategoryChange}
                                option={this.props.categories.map((category) => {
                                    return { value: category.id, label: category.name }
                                })}
                            />
                            <TextEditorCustom
                                label="เนื้อหา"
                            />
                            <div className="is-row is-sm-row-reverse gapt-32 flex-end">
                                <div className="gapr-12 sm-gapr-0 is-sm-100" style={{minWidth: 160}}>
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="outline-gray"
                                        label="ยกเลิก"
                                        fontSize={16}
                                        fontWeight="large"
                                        size="extra"
                                        className="center"
                                        href={`/topic/${id}`}
                                    />
                                </div>
                                <div className="is-sm-100 sm-gapb-12" style={{minWidth: 160}}>
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="green"
                                        label="ยืนยัน"
                                        fontSize={16}
                                        fontWeight="large"
                                        size="extra"
                                        className="center"
                                        htmlType="submit"
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            );
        } else{
            return null
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
        categories: state.categories,
        board: state.board
    }
}

const mapDispatchToProps = {
    fetchCategoriesBoard,
    updateBoard,
    fetchBoard
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTopic)
